// extracted by mini-css-extract-plugin
module.exports = {"big":"AvatarOverflow-big-2Z1qBN","small":"AvatarOverflow-small-2OFxxt"};